import * as CL from '@design-system/component-library';
import { Link, useLocation } from 'react-router';
import { REDIRECT_PATH_KEY } from '../../common/constants/commonConstants.js';
import { paths } from '../../common/constants/pathVariables.js';
import { t } from '../../common/i18n/index.js';
import { useAuth } from '../../public/site/AuthProvider.js';
import { useDialog } from '../../public/site/DialogProvider.js';
import { MigrationLogin } from '../Login/MigrationLogin.js';
import { Login } from '../Login/index.js';

import './LoginAndRegistration.scss';

interface LoginAndRegistrationProps {
  includeAdmins?: boolean;
}

export const LoginAndRegistration = ({ includeAdmins = false }: LoginAndRegistrationProps) => {
  const { pathname } = useLocation();
  const dialog = useDialog();
  const { anonymousUser, inMigrationPhase } = useAuth();

  if (inMigrationPhase) {
    return <MigrationLogin dialog={dialog} includeAdmins={includeAdmins} />;
  }

  return (
    <div className="of-login-registration-container">
      <div className="of-login-registration-container__login">
        <Login dialog={dialog} />
      </div>
      {!anonymousUser?.mfaInfo && (
        <div className="of-login-registration-container__registration">
          <h3>{t.ELJA('I am a new customer.')}</h3>
          <Link to={`${paths.REGISTER_PAGE}?${REDIRECT_PATH_KEY}=${encodeURIComponent(pathname)}`}>
            <CL.Button size="l">{t.LJTY('Register')}</CL.Button>
          </Link>
        </div>
      )}
    </div>
  );
};
